import React from 'react';

import TrplSelect from '../../TrplControls/TrplSelect';
import TrplSelectWithTextfield from '../../TrplControls/TrplSelectWithTextfield';

import FuzzyVal from './FuzzyVal';

import InfoAlert from './InfoAlert';
import CreateTrplBtn from './CreateTrplBtn';
import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import TrplErrorAlertIcon from './TrplErrorAlertIcon';
import MandatoryAlertIcon from './MandatoryAlertIcon';

import { shouldShowTrplAsEdited } from '../../../utils';

export default ({
  rst,
  trpls,
  type,
  classes,
  setTrpl,
  groupId,
  constant,
  isVirtual,
  isNewNode,
  ancestorId,
  tidsChains,
  loadingTids,
  deletedTids,
  hideSetDelete,
  isAnotherNode,
  onRstValueEdit,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  resetDeletedTrplId,
  disableTrplEditing,
  showMandatoryAlert,
  showEmptyValOnBounds,
  updateDataOnRestoreTrpl,
}) => {
  const itemStyles = {
    minHeight: '34px',
    lineHeight: 'normal',
  };

  const menuProps = {
    classes: {
      paper: classes.trplSelectMenu,
    },
  };

  const notEditable = constant || disableTrplEditing;

  return (
    <React.Fragment>
      {trpls.map((trpl, trplIndex) => {
        const disabledDefaultField = rst.has_def_val && !trpl.tid && isNewNode;
        const showMandatoryField = showMandatoryAlert && !trpl.tid;

        // TODO move to utils
        const selectClasses = {
          root: `${classes.trplSelect} ${classes.trplSelectContainer} ${classes.absolute} ${shouldShowTrplAsEdited(trpl)
            ? classes.trplEdited
            : showMandatoryField
              ? classes.mandatoryField
              : isVirtual && notEditable
              ? classes.notEditableVirtualTrpl
              : isVirtual
                ? classes.trplVirtual
                : notEditable && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                : trpl && trpl.tid
                  ? classes.trplWithValue
                  : classes.trplEmpty
            }`,
          select: classes.trplSelect,
          icon: classes.trplSelectIcon,
        };

        return (
          <div
            key={`${rst.title}.${trplIndex}`}
            className={`${classes.flex} ${trplIndex === 0 ? '' : classes.mt5} ${classes.alignCenter}`}>
            <div style={{ width: '100%', height: '23px' }}>
              {!rst.hasOwnProperty('is_bounds_strict') || rst.is_bounds_strict ?
                <TrplSelect
                  fullWidth
                  margin="none"
                  values={rst.values}
                  MenuProps={menuProps}
                  value={trpl.val || ''}
                  itemStyles={itemStyles}
                  selectClasses={selectClasses}
                  addEmptyItem={showEmptyValOnBounds}
                  disabled={constant || disabledDefaultField || disableTrplEditing}
                  onChange={(e) => {
                    onRstValueEdit(rst, e.target.value, trplIndex, ancestorId, tidsChains && trpl.tid && tidsChains[trpl.tid]);
                  }}
                />
              :
                <TrplSelectWithTextfield
                  type={'text'}
                  freeSolo={true}
                  fullWidth={true}
                  values={rst.values}
                  value={trpl.val || ''}
                  selectClasses={selectClasses}
                  indKey={`${rst.id}.${rst.title}.${trplIndex}`}
                  disabled={constant || disabledDefaultField || disableTrplEditing}
                  onChange={(value) => {
                    onRstValueEdit(rst, value, trplIndex, ancestorId, tidsChains && trpl.tid && tidsChains[trpl.tid]);
                  }}
                />
              }

              {trpl.val_fuzzy ?
                <div className={`${classes.fillAvailable} ${classes.justifyEnd} ${classes.relative}`}>
                  <FuzzyVal
                    top={'-30px'}
                    right={'20px'}
                    classes={classes}
                    value={trpl.val_fuzzy}
                  />
                </div>
              : null}
            </div>

            <TrplErrorAlertIcon trpl={trpl} />
            {!trpl.tid && showMandatoryAlert && <MandatoryAlertIcon />}
            {disabledDefaultField && <InfoAlert />}

            {hideSetDelete ? null : trpl.tid ?
              <SetDeleteTrplBtns
                rst={rst}
                type={type}
                trpl={trpl}
                groupId={groupId}
                classes={classes}
                setTrpl={setTrpl}
                trplIndex={trplIndex}
                ancestorId={ancestorId}
                loadingTids={loadingTids}
                isAnotherNode={isAnotherNode}
                setLoadingTids={setLoadingTids}
                removeTrplValue={removeTrplValue}
                setDeletedTrplId={setDeletedTrplId}
                constant={constant || disableTrplEditing}
              />
              :
              <CreateTrplBtn
                rst={rst}
                trpl={trpl}
                classes={classes}
                setTrpl={setTrpl}
                trplIndex={trplIndex}
                isNewNode={isNewNode}
                ancestorId={ancestorId}
                loadingTids={loadingTids}
                deletedTids={deletedTids}
                isAnotherNode={isAnotherNode}
                setLoadingTids={setLoadingTids}
                resetDeletedTrplId={resetDeletedTrplId}
                disableTrplEditing={disableTrplEditing}
                constant={constant || disabledDefaultField}
                updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              />
            }
          </div>
        );
      }
      )}
    </React.Fragment>
  );
};
